module.exports = __webpack_public_path__ + "img/02_14-1.65279b88.jpg";